/* eslint-disable */

import React, { useEffect, useState } from 'react';

// material
import { styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import {
  Box,
  Button,
  Typography,
  Container,
  Table,
  Card,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Snackbar,
  Alert,
  Stack,
  CircularProgress,
  Pagination,
  Tooltip,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Paper
} from '@mui/material';

import { URL_CONSTANT } from '../URLConstants';
import ConfirmAlertDialog from '../components/ConfirmDialog';
import { fNumber } from '../utils/formatNumber';
// components
import Page from '../components/Page';
import {
  AddSmartLockDeviceModal,
  DeviceMoreMenu,
  DeviceSettingsModal
} from '../components/_dashboard/smartlock';
import { DeleteDeviceById, GetAllDevices, GetDeviceDetailById } from '../network/Devices';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import moment from 'moment';
import { getBatteryIcon, getColorAccordingBattery, truncateText } from '../utils/Parser';
import { useLocation, useNavigate } from 'react-router-dom';
import UploadSmartLockDevice from '../components/_dashboard/smartlock/UploadSmartLockDevice';
import { ReactComponent as LockCloseIcon } from '../icons/lockClose.svg';
import { ReactComponent as LockOpenIcon } from '../icons/LockOpen.svg';
import { ReactComponent as LockErrorIcon } from '../icons/LockError.svg';
import BatteryChargingFullOutlinedIcon from '@mui/icons-material/BatteryChargingFullOutlined';
import useFeatures from '../components/customContextProviders/FeatureContext';
import Header from '../components/navbar/Header';
import AssignOrganizationModal from '../components/_dashboard/smartlock/AssignOrganizationModal';
import { useAuth } from '../components/customContextProviders/AuthContext';
import NoDataAvailable from '../components/_dashboard/smartlock/NoDataAvailable';
import { HeaderHeight, PageHeaderHeight } from '../Constants';

// ----------------------------------------------------------------------

const useStyles = makeStyles((theme) => ({
  tableCellStyle: {
    fontSize: {
      xs: '12px',
      md: '14px'
    },
    fontWeight: 700,
    padding: {
      xs: '8px',
      md: '16px'
    },
    textWrap: 'nowrap',
    backgroundColor: '#FFFFFF'
  },
  tableCellFlex: {
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    cursor: 'pointer'
  },
  tableCellWidth100: {
    minWidth: '100px'
  },
  tableCellWidth110: {
    minWidth: '110px'
  },
  tableCellWidth150: {
    minWidth: '150px'
  },
  menuItem: {
    fontSize: '14px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px'
    },
    minHeight: '20px',
    borderRadius: '8px',
    marginInline: theme.spacing(1)
  },
  tablePaper: {
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    backgroundColor: '#FFFFFF'
  },
  tableContainer: {
    flexGrow: 1,
    height: `calc(100vh - ${HeaderHeight + PageHeaderHeight + 56 + 40}px)`,
    overflow: 'auto'
  }
}));

const LoaderContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '50px'
});

const PageHeader = styled('Box')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'start',
  gap: 1,
  flexDirection: 'row',
  height: '50px'
}));

export default function Devices() {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const feature = useFeatures();
  const { sessionUserData } = useAuth();

  const userRole = sessionUserData?.user?.userRole?.roleName;

  const devcieStatus = location?.state?.status || '';

  const [open, setOpen] = useState(false);
  const [smartLockDeviceListData, setSmartLockDeviceListData] = useState([]);
  const [isAssignedDeviceModal, setAssignedDeviceModal] = useState(false);
  const [isAssignVehicleModal, setAssignVehicalModal] = useState(false);
  const [isAddSmartLockDeviceModal, setIsAddSmartLockDeviceModal] = useState(false);
  const [isDeviceSettingsModal, setIsDeviceSettingsModal] = useState(false);
  const [isDeviceSettingsModalOld, setIsDeviceSettingsModalOld] = useState(false);
  const [selectedDeviceData, setSelectedDeviceData] = useState({});
  const [deviceActionModal, setDeviceActionModal] = useState(false);
  const [sortFilterValue, setSortFilterValue] = useState('ASC');
  const [isEditDriverModalOpen, setIsEditDriverModalOpen] = useState(false);
  const [openConfirmAlertDialog, setOpenConfirmAlertDialog] = useState(false);
  const [isAssignDeviceUploadModal, setIsAssignDeviceUploadModal] = useState(false);
  const [organizationModal, setOrganizationModal] = useState(false);
  const [filterByDeviceStatus, setFilterByDeviceStatus] = useState('');
  const [confirmAlertDialogMetas, setConfirmAlertDialogMetas] = useState({
    message: '',
    title: '',
    positiveBtnLable: '',
    negativeBtnLabel: ''
  });

  const [alertMetas, setAlertMetas] = useState({
    snackBarOpened: false,
    vertical: 'top',
    horizontal: 'right',
    msg: '',
    variant: 'filled',
    severity: ''
  });
  const [initialRender, setInitialRender] = useState(false);
  const [cityNames, setCityNames] = useState([]);
  const [updateDevice, setUpdateDevice] = useState(false);
  const [deviceDetail, setDeviceDetail] = useState({});
  const [loader, setLoader] = useState(false);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const vertical = 'bottom';
  const horizontal = 'left';

  const handleSnackBarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setAlertMetas({ ...alertMetas, snackBarOpened: false });
  };

  const showLockIcon = (lock_status) => {
    switch (lock_status) {
      case 'CLOSE':
        return LockCloseIcon ? <LockCloseIcon /> : null;
      case 'OPEN':
        return LockOpenIcon ? <LockOpenIcon /> : null;
      default:
        return LockErrorIcon ? <LockErrorIcon /> : null;
    }
  };

  const handleUserMoreMenuClick = (action, deviceData) => {
    switch (action) {
      case 'add': {
        setAssignedDeviceModal(true);
        break;
      }
      case 'device_settings': {
        setIsDeviceSettingsModal(true);
        setSelectedDeviceData(deviceData);
        break;
      }

      case 'delete_device': {
        setSelectedDeviceData(deviceData);
        setConfirmAlertDialogMetas({
          ...confirmAlertDialogMetas,
          message: 'Are you sure want to delete this device ?',
          title: 'Delete',
          positiveBtnLable: 'Confirm',
          negativeBtnLabel: 'Cancel'
        });
        setOpenConfirmAlertDialog(true);
        break;
      }
      case 'view_trips': {
        if (deviceData?.tripData) {
          navigate(URL_CONSTANT.TRIP_DETAIL, { state: { tripData: deviceData?.tripData } });
        } else {
          setAlertMetas({
            ...alertMetas,
            severity: 'info',
            snackBarOpened: true,
            msg: 'Device is not assigned to any trip !'
          });
          setTimeout(() => setAlertMetas({ ...alertMetas, snackBarOpened: false, msg: '' }), 4000);
        }
        break;
      }
      case 'device_report': {
        if (deviceData) {
          navigate(URL_CONSTANT.DEVICE_REPORT, { state: { deviceId: deviceData?.id } });
        }
        break;
      }
      case 'update_organization': {
        setSelectedDeviceData(deviceData);
        setOrganizationModal(true);
      }
      default: {
        return;
      }
    }
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const getAllDevices = async (page, search, filterByDeviceStatus, sortFilterValue) => {
    setLoader(true);
    try {
      const res = await GetAllDevices(page, search, filterByDeviceStatus, sortFilterValue);
      setSmartLockDeviceListData(res?.data);
    } catch (err) {
      console.error('Error fetching devices:', err);
    } finally {
      setLoader(false);
    }
  };

  // const getDeviceDetailById = async (id) => {
  //   try {
  //     const res = await GetDeviceDetailById(id);
  //     setDeviceDetail(res?.data);
  //   } catch (err) {
  //     console.log('Error fetching device detail:', err);
  //   }
  // };

  const deleteDeviceById = async (deviceId) => {
    try {
      const res = await DeleteDeviceById(deviceId);
      if (res) {
        setAlertMetas({
          ...alertMetas,
          severity: 'error',
          snackBarOpened: true,
          msg: 'Device Deleted !'
        });
        setTimeout(() => setAlertMetas({ ...alertMetas, snackBarOpened: false, msg: '' }), 4000);
      }
    } catch (error) {
      setAlertMetas({
        ...alertMetas,
        severity: 'error',
        snackBarOpened: true,
        msg: error?.response?.data?.message
      });
    } finally {
      onAddDeviceModalAction();
      setTimeout(() => setAlertMetas({ ...alertMetas, snackBarOpened: false, msg: '' }), 4000);
    }
  };

  const onAddDeviceModalAction = (d) => {
    getAllDevices(page, search, filterByDeviceStatus, sortFilterValue);
  };

  const handleDeviceSearch = (value) => {
    setSearch(value);
  };

  const handleSortFilterChange = (event) => {
    setSortFilterValue(event.target.value);
  };

  const SearchDevices = () => {
    setPage(1);
    getAllDevices(page, search, filterByDeviceStatus, sortFilterValue);
  };

  const handleFilter = (event) => {
    setPage(1);
    setFilterByDeviceStatus(event.target.value);
  };

  useEffect(() => {
    const fetchCityNames = async () => {
      if (smartLockDeviceListData?.data) {
        const names = await Promise.all(
          smartLockDeviceListData.data.map(async (row) => {
            try {
              // Ensure latestEvent is not null and lat/lng are not 0
              if (
                row?.latestEvent &&
                row.latestEvent.location_lat !== 0 &&
                row.latestEvent.location_lng !== 0
              ) {
                const city = await getLocationFromLatLng(
                  row.latestEvent.location_lat,
                  row.latestEvent.location_lng
                );
                return city || '---';
              } else {
                // If lat/lng is 0 or latestEvent is null, return '---'
                return '---';
              }
            } catch (error) {
              return '---';
            }
          })
        );
        setCityNames(names);
      }
    };

    fetchCityNames();
  }, [smartLockDeviceListData]);

  useEffect(() => {
    if (devcieStatus) {
      setFilterByDeviceStatus(devcieStatus);
    }
    setInitialRender(true);
  }, [devcieStatus]);

  useEffect(() => {
    if (initialRender) {
      const timeout = setTimeout(() => {
        getAllDevices(page, search, filterByDeviceStatus, sortFilterValue);
      }, 300); // Debounce with 300ms
      return () => clearTimeout(timeout);
    }
  }, [page, search, filterByDeviceStatus, sortFilterValue, initialRender]);

  return (
    <Page title="Devices">
      <Header
        onOpenSidebar={() => setOpen(true)}
        handleSearch={handleDeviceSearch}
        handleSubmit={SearchDevices}
        name="Device Management"
        showSearch={true}
      />
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={alertMetas?.snackBarOpened}
        onClose={handleSnackBarClose}
        autoHideDuration={6000}
      >
        <Alert variant={alertMetas?.variant} severity={alertMetas?.severity}>
          {alertMetas?.msg}
        </Alert>
      </Snackbar>

      <Container maxWidth="false" disableGutters sx={{ padding: 0 }}>
        <PageHeader>
          {/* {userRole.toUpperCase() === 'SUPERADMIN' && (
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Button
                variant="outlined"
                size="medium"
                onClick={() => setIsAddSmartLockDeviceModal(true)}
                sx={{ backgroundColor: '#FFFFFF', boxShadow: '0px 10px 19px 1px #EAEAFF' }}
              >
                Add Device
              </Button>

              <Button
                variant="outlined"
                size="medium"
                onClick={() => setIsAssignDeviceUploadModal(true)}
                sx={{ backgroundColor: '#FFFFFF', boxShadow: '0px 10px 19px 1px #EAEAFF' }}
              >
                Bulk Upload
              </Button>
            </Box>
          )} */}

          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              py: { xs: 1, sm: 0 },
              gap: { xs: 1, sm: 2 },
              alignItems: 'center'
            }}
          >
            <FormControl data-testid="device-status-select" size="small" sx={{ minWidth: 130 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Typography
                  sx={{
                    fontSize: { xs: '12px', sm: '14px' },
                    fontWeight: 600
                  }}
                >
                  Device Status
                </Typography>
                <Select
                  sx={{
                    fontSize: { xs: '12px', sm: '14px' },
                    fontWeight: '500',
                    minWidth: '130px',
                    borderRadius: '12px'
                  }}
                  labelId="device-filter-select-label"
                  id="device-filter-select"
                  value={filterByDeviceStatus}
                  onChange={handleFilter}
                  IconComponent={ExpandMoreIcon}
                >
                  <MenuItem className={classes.menuItem} value={''}>
                    All
                  </MenuItem>
                  <MenuItem className={classes.menuItem} value={'offline'}>
                    OFFLINE
                  </MenuItem>
                  <MenuItem className={classes.menuItem} value={'online'}>
                    ONLINE
                  </MenuItem>
                </Select>
              </Box>
            </FormControl>

            <FormControl data-testid="device-sort-filter" size="small">
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Typography sx={{ fontSize: { xs: '12px', sm: '14px' }, fontWeight: 600 }}>
                  Sort By
                </Typography>
                <Select
                  sx={{
                    fontSize: { xs: '12px', sm: '14px' },
                    fontWeight: '500',
                    minWidth: '130px',
                    maxHeight: '37.13px',
                    borderRadius: '12px',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                  id="device_sort_filter"
                  IconComponent={ExpandMoreIcon}
                  value={sortFilterValue}
                  onChange={handleSortFilterChange}
                >
                  <MenuItem className={classes.menuItem} value="ASC">
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        width: '100%'
                      }}
                    >
                      <Typography sx={{ fontSize: { xs: '12px', sm: '14px' }, fontWeight: 500 }}>
                        Last Comm.
                      </Typography>{' '}
                      <ExpandMoreIcon />
                    </Box>
                  </MenuItem>
                  <MenuItem className={classes.menuItem} value="DESC">
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        width: '100%'
                      }}
                    >
                      <Typography sx={{ fontSize: { xs: '12px', sm: '14px' }, fontWeight: 500 }}>
                        Last Comm.
                      </Typography>{' '}
                      <ExpandLessIcon />
                    </Box>
                  </MenuItem>
                </Select>
              </Box>
            </FormControl>
          </Box>
        </PageHeader>

        <Box sx={{ width: '100%', typography: 'body1' }}>
          <Card sx={{ width: '100%' }}>
            <Paper className={classes.tablePaper}>
              <TableContainer data-testid="device-data-table" className={classes.tableContainer}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell className={classes.tableCellStyle} width={150}>
                        Device
                      </TableCell>
                      {/* <TableCell align="left" sx={{ fontWeight: 'bold' }} width={100}>
                      Status
                    </TableCell> */}
                      <TableCell align="left" className={classes.tableCellStyle} width={300}>
                        Last Comm
                      </TableCell>
                      <TableCell align="left" className={classes.tableCellStyle} width={200}>
                        Battery
                      </TableCell>
                      <TableCell align="left" className={classes.tableCellStyle} width={100}>
                        Driver
                      </TableCell>
                      <TableCell align="left" className={classes.tableCellStyle} width={100}>
                        Trip
                      </TableCell>
                      <TableCell align="left" className={classes.tableCellStyle} width={100}>
                        Vehicle
                      </TableCell>
                      <TableCell align="left" className={classes.tableCellStyle} width={100}>
                        Vehicle No
                      </TableCell>

                      <TableCell align="left" className={classes.tableCellStyle} width={100}>
                        Location
                      </TableCell>
                      {userRole.toUpperCase() === 'SUPERADMIN' && (
                        <TableCell align="left" className={classes.tableCellStyle} width={100}>
                          Assigned Organization
                        </TableCell>
                      )}
                      <TableCell align="left" className={classes.tableCellStyle}></TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {smartLockDeviceListData?.data?.length === 0 && (
                      <TableRow>
                        <TableCell colSpan={10}>
                          <NoDataAvailable />
                        </TableCell>
                      </TableRow>
                    )}
                    {loader ? (
                      <TableRow>
                        <TableCell colSpan={10}>
                          <LoaderContainer>
                            <CircularProgress size={30} />
                          </LoaderContainer>
                        </TableCell>
                      </TableRow>
                    ) : (
                      smartLockDeviceListData?.data?.map((row, index) => (
                        <TableRow
                          key={row?.id}
                          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                          <TableCell
                            component="th"
                            scope="row"
                            align="left"
                            sx={{
                              minWidth: '5vw',
                              textWrap: 'nowrap',
                              textTransform: 'capitalize',
                              padding: {
                                xs: '8px',
                                md: '16px'
                              },
                              fontSize: {
                                xs: '12px',
                                md: '14px' // Larger screens
                              }
                            }}
                          >
                            <div
                              className={classes.tableCellFlex}
                              onClick={() => handleUserMoreMenuClick('device_report', row)}
                            >
                              <Tooltip
                                title={
                                  row?.latestEvent?.lock_status?.toUpperCase() === 'CLOSE'
                                    ? 'Lock Close'
                                    : 'Lock Open'
                                }
                                placement="top"
                              >
                                <IconButton data-testid="lock-status-icon">
                                  {showLockIcon(row?.latestEvent?.lock_status)}
                                </IconButton>
                              </Tooltip>

                              <Typography
                                sx={{
                                  fontSize: {
                                    xs: '12px',
                                    md: '14px' // Larger screens
                                  },
                                  fontWeight: '600',
                                  color:
                                    row?.deviceLiveStatus?.toUpperCase() === 'OFFLINE'
                                      ? '#C30A0A'
                                      : '#0DA626'
                                }}
                              >
                                {row?.name ? row?.name : '---'}
                              </Typography>
                            </div>
                          </TableCell>
                          {/* <TableCell align="left" sx={{ minWidth: '50px' }}>
                          {
                            <SignalCellularAltIcon
                              sx={{
                                color:
                                  row?.deviceLiveStatus?.toUpperCase() === 'OFFLINE'
                                    ? '#C30A0A'
                                    : '#0DA626'
                              }}
                            />
                          }
                        </TableCell> */}
                          <TableCell
                            component="th"
                            scope="row"
                            align="left"
                            sx={{
                              minWidth: '5vw',
                              textWrap: 'nowrap',
                              textTransform: 'capitalize',
                              padding: {
                                xs: '8px',
                                md: '16px'
                              },
                              fontSize: {
                                xs: '12px',
                                md: '14px' // Larger screens
                              }
                            }}
                          >
                            {row?.latestEvent?.createdAt
                              ? moment(row.latestEvent.createdAt)
                                  .add(5, 'hours')
                                  .add(30, 'minutes')
                                  .format('DD-MM-YYYY hh:mm:ss A')
                              : '---'}

                            {/* {row?.latestEvent?.timestamp ? (
                              moment(row?.latestEvent?.timestamp)?.format('DD-MM-YYYY hh:mm:ss a')
                            ) : (
                              <Typography>--</Typography>
                            )} */}
                          </TableCell>
                          <TableCell
                            align="left"
                            sx={{
                              minWidth: '5vw',
                              textWrap: 'nowrap',
                              textTransform: 'capitalize',
                              padding: {
                                xs: '8px',
                                md: '16px'
                              },
                              fontSize: {
                                xs: '12px',
                                md: '14px' // Larger screens
                              }
                            }}
                          >
                            {row?.latestEvent?.battery_remaining !== null &&
                            row?.latestEvent?.battery_remaining !== undefined ? (
                              <Stack
                                direction="row"
                                alignItems="center"
                                spacing={1}
                                justifyContent="flex-start"
                              >
                                {row?.latestEvent?.battery_charging ? (
                                  <BatteryChargingFullOutlinedIcon
                                    fontSize="small"
                                    sx={{
                                      color: getColorAccordingBattery(
                                        row?.latestEvent?.battery_remaining
                                      )
                                    }}
                                  />
                                ) : (
                                  getBatteryIcon(
                                    row?.latestEvent?.battery_remaining,
                                    getColorAccordingBattery(row?.latestEvent?.battery_remaining)
                                  )
                                  // <Battery3BarIcon
                                  //   sx={{
                                  //     width: '20px',
                                  //     height: '20px',
                                  //     color: getColorAccordingBattery(
                                  //       row?.latestEvent?.battery_remaining
                                  //     )
                                  //   }}
                                  // />
                                )}
                                <Typography>
                                  {fNumber(row?.latestEvent?.battery_remaining)} %
                                </Typography>
                              </Stack>
                            ) : (
                              <Typography>---</Typography>
                            )}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            align="left"
                            sx={{
                              minWidth: '5vw',
                              textWrap: 'nowrap',
                              textTransform: 'capitalize',
                              padding: {
                                xs: '8px',
                                md: '16px'
                              },
                              fontSize: {
                                xs: '12px',
                                md: '14px' // Larger screens
                              }
                            }}
                          >
                            {row?.tripData?.driver_name ? (
                              row?.tripData?.driver_name
                            ) : (
                              <Typography>---</Typography>
                            )}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            align="left"
                            sx={{
                              minWidth: '5vw',
                              textWrap: 'nowrap',
                              textTransform: 'capitalize',
                              cursor: 'pointer',
                              padding: {
                                xs: '8px',
                                md: '16px'
                              },
                              fontSize: {
                                xs: '12px',
                                md: '14px' // Larger screens
                              }
                            }}
                          >
                            <Tooltip placement="top" title={row?.tripData?.name || '---'}>
                              <span>
                                {row?.tripData?.name
                                  ? truncateText(row?.tripData?.name, 30)
                                  : '---'}
                              </span>
                            </Tooltip>
                          </TableCell>

                          <TableCell
                            component="th"
                            scope="row"
                            align="left"
                            sx={{
                              minWidth: '5vw',
                              textWrap: 'nowrap',
                              textTransform: 'capitalize',
                              padding: {
                                xs: '8px',
                                md: '16px'
                              },
                              fontSize: {
                                xs: '12px',
                                md: '14px' // Larger screens
                              }
                            }}
                          >
                            {row?.vehicledata?.name ? (
                              row?.vehicledata?.name
                            ) : (
                              <Typography>---</Typography>
                            )}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            align="left"
                            sx={{
                              minWidth: '5vw',
                              textWrap: 'nowrap',
                              textTransform: 'capitalize',
                              padding: {
                                xs: '8px',
                                md: '16px'
                              },
                              fontSize: {
                                xs: '12px',
                                md: '14px' // Larger screens
                              }
                            }}
                          >
                            {row?.vehicledata?.registration_no ? (
                              row?.vehicledata?.registration_no
                            ) : (
                              <Typography>---</Typography>
                            )}
                          </TableCell>

                          <TableCell
                            align="left"
                            sx={{
                              minWidth: '5vw',
                              textWrap: 'nowrap',
                              textTransform: 'capitalize',
                              padding: {
                                xs: '8px',
                                md: '16px'
                              },
                              fontSize: {
                                xs: '12px',
                                md: '14px' // Larger screens
                              }
                            }}
                          >
                            {row?.latestEvent === null ? '---' : cityNames[index]}
                          </TableCell>
                          {userRole?.toUpperCase() === 'SUPERADMIN' && (
                            <TableCell
                              align="left"
                              sx={{
                                minWidth: '5vw',
                                textWrap: 'nowrap',
                                textTransform: 'capitalize',
                                padding: {
                                  xs: '8px',
                                  md: '16px'
                                },
                                fontSize: {
                                  xs: '12px',
                                  md: '14px' // Larger screens
                                }
                              }}
                            >
                              {row?.organization_name !== null ? row?.organization_name : '---'}
                            </TableCell>
                          )}
                          <TableCell
                            align="right"
                            sx={{
                              padding: {
                                xs: '8px',
                                md: '16px'
                              }
                            }}
                          >
                            <DeviceMoreMenu
                              handleUser={row}
                              handleClicks={(e) => handleUserMoreMenuClick(e, row)}
                            />
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              {smartLockDeviceListData?.data?.length !== 0 && (
                <Stack
                  sx={{
                    marginTop: '10px',
                    marginBottom: '10px'
                  }}
                >
                  <Pagination
                    style={{ display: 'flex', justifyContent: 'flex-end' }}
                    count={smartLockDeviceListData?.totalPages}
                    showFirstButton
                    showLastButton
                    onChange={handlePageChange}
                    page={page}
                    total={smartLockDeviceListData?.total}
                    sx={{
                      '& .MuiPaginationItem-root': {
                        padding: '8px', // Adjust padding for buttons
                        minWidth: {
                          xs: '24px',
                          md: '32px'
                        },
                        height: {
                          xs: '24px',
                          md: '32px'
                        },
                        fontSize: {
                          xs: '12px',
                          md: '14px' // Larger screens
                        }
                      }
                    }}
                  />
                </Stack>
              )}
            </Paper>
          </Card>
        </Box>

        {/* {isAddSmartLockDeviceModal && (
          <AddSmartLockDeviceModal
            openAssignedModal={isAddSmartLockDeviceModal}
            handleClose={() => setIsAddSmartLockDeviceModal(false)}
            onAction={(d) => onAddDeviceModalAction(d)}
            isEdit={updateDevice}
            deviceDetail={deviceDetail}
            alertMetas={alertMetas}
            setAlertMetas={setAlertMetas}
          />
        )} */}
        {isDeviceSettingsModal && (
          <DeviceSettingsModal
            openAssignedModal={isDeviceSettingsModal}
            handleClose={() => setIsDeviceSettingsModal(false)}
            deviceDetail={selectedDeviceData}
            onAction={(d) => onAddDeviceModalAction(d)}
            setAlertMetas={setAlertMetas}
            alertMetas={alertMetas}
          />
        )}

        {/* <UploadSmartLockDevice
          openAssignedModal={isAssignDeviceUploadModal}
          handleClose={() => setIsAssignDeviceUploadModal(false)}
          onAction={(d) => onAddDeviceModalAction(d)}
        /> */}

        {organizationModal && (
          <AssignOrganizationModal
            openAssignedModal={organizationModal}
            handleClose={() => setOrganizationModal(false)}
            deviceDetail={selectedDeviceData}
            setAlertMetas={setAlertMetas}
            alertMetas={alertMetas}
          />
        )}

        <ConfirmAlertDialog
          openConfirmAlertDialog={openConfirmAlertDialog}
          message={confirmAlertDialogMetas?.message}
          title={confirmAlertDialogMetas?.title}
          positiveBtnLable={confirmAlertDialogMetas?.positiveBtnLable}
          negativeBtnLable={confirmAlertDialogMetas?.negativeBtnLabel}
          handleClose={() => setOpenConfirmAlertDialog(false)}
          handlePositiveClose={() => {
            deleteDeviceById(selectedDeviceData?.id);
            setOpenConfirmAlertDialog(false);
          }}
          handleNegativeClose={() => setOpenConfirmAlertDialog(false)}
        />
      </Container>
    </Page>
  );
}
